'use client'

import Image from 'next/image'
import Link from 'next/link'
import React, { ComponentProps } from 'react'

export const TrialBanner = (props: Partial<ComponentProps<typeof Image>>) => {
  const href = '/subscribes/trial'

  return (
    <header aria-label="trial-banner">
      <Link href={href}>
        <Image
          src="/images/banners/trial-free.png"
          alt="trial banner"
          width={400}
          height={549}
          className="w-full h-auto"
          priority
          {...props}
        />
      </Link>
    </header>
  )
}
